
// Libraries
import { Component, Vue, Prop, Emit } from "nuxt-property-decorator";
import sortOptions from "~/defaults/heizoelpreise/sortOptions";

// eslint-disable-next-line
type sortOptions = "bad" | "best" | "old" | "new";

@Component({})
export default class SortHeaderOrganism extends Vue {
  @Prop({ default: "Anzahl" }) counterLabel: number;
  @Prop({ default: 0 }) counterValue: number;
  @Prop({ required: true }) loadedAmount: number;

  sortOptions = {
    value: {
      time: true,
      satisfaction: false,
    },
    sortDescTime: false,
    sortDescSati: false,
  };

  sortGoodBad = "best";
  sortNewOld = "new";
  lastSelectedTab = "time";
  activeSelectedTab = "time";

  toggleBestSortDirection(highest: string, lowest: string, tab: string) {
    this.lastSelectedTab = this.activeSelectedTab;
    this.activeSelectedTab = tab;
    if (this.lastSelectedTab === this.activeSelectedTab) {
      if (highest === "new") {
        if (this.sortNewOld === highest) {
          this.sortNewOld = lowest;
          return lowest;
        }
        this.sortNewOld = highest;
        return highest;
      } else {
        if (this.sortGoodBad === highest) {
          this.sortGoodBad = lowest;
          return lowest;
        }
        this.sortGoodBad = highest;
        return highest;
      }
    } else {
      if (this.activeSelectedTab === "time") {
        return this.sortNewOld;
      } else {
        return this.sortGoodBad;
      }
    }
  }

  toggleSortDirection(direction: boolean | null, sortCase: string | null) {
    if (direction === null) {
      sortCase === "satisfaction"
        ? (this.sortOptions.sortDescSati = !this.sortOptions.sortDescSati)
        : (this.sortOptions.sortDescTime = !this.sortOptions.sortDescTime);
    } else {
      sortCase === "satisfaction"
        ? (this.sortOptions.sortDescSati = direction)
        : (this.sortOptions.sortDescTime = direction);
    }
  }

  setActiveSortOption(sortOption: sortOptions) {
    if (sortOption === null) this.sortOptions.value.time = true;
    if (sortOption === "best") {
      this.sortOptions.value.satisfaction = true;
      this.sortOptions.value.time = false;
    }
    if (sortOption === "bad") {
      this.sortOptions.value.satisfaction = true;
      this.sortOptions.value.time = false;
    }
    if (sortOption === "new") {
      this.sortOptions.value.satisfaction = false;
      this.sortOptions.value.time = true;
    }
    if (sortOption === "old") {
      this.sortOptions.value.satisfaction = false;
      this.sortOptions.value.time = true;
    }
  }

  @Emit()
  emitSelectedValue(value) {
    if (value === "new" && this.sortOptions.value.time === true)
      this.toggleSortDirection(null, "date");
    if (value === "old" && this.sortOptions.value.time === true)
      this.toggleSortDirection(true, "date");
    if (value === "best" && this.sortOptions.value.satisfaction === true)
      this.toggleSortDirection(null, "satisfaction");
    if (value === "bad" && this.sortOptions.value.satisfaction === true)
      this.toggleSortDirection(true, "satisfaction");
    this.setActiveSortOption(value);
    return value;
  }
}
